import { FormsContext } from 'providers/forms'
import React from 'react'

export const useForm = () => {
  const context = React.useContext(FormsContext)
  if (context === undefined) {
    throw new Error('useForm must be used within a FormsProvider')
  }
  return context
}

export default function validate(values) {
  const errors = {}
  if (!values.email) {
    errors.email = 'Email address is required'
  } else if (!/\S+@\S+\.\S+/.test(values.email)) {
    errors.email = 'Email address is invalid'
  }
  return errors
}
